import React from "react";

export default function ErrorPage({ error, onReset }) {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-background-dark to-surface-1">
      <div className="max-w-md w-full mx-auto px-6 py-12 bg-surface-1 sheen-2 rounded-lg shadow-elevated border border-danger/20">
        {/* Error Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-danger/10 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 text-danger"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4v.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        {/* Error Message */}
        <h1 className="text-2xl font-bold text-text-primary text-center mb-2">
          Algo salió mal
        </h1>
        <p className="text-text-dim text-center mb-6">
          Ha ocurrido un error inesperado. No te preocupes, hemos registrado el
          problema.
        </p>

        {/* Error Details (Development Only) */}
        {error && (
          <div className="mb-6 p-4 bg-danger/5 border border-danger/20 rounded text-xs text-danger max-h-32 overflow-y-auto font-mono">
            {error.toString()}
          </div>
        )}

        {/* Action Button */}
        <button
          onClick={onReset}
          className="w-full py-3 px-4 bg-primary sheen-control shadow-control-primary hover:bg-primary/90 text-white font-semibold rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 12a9 9 0 019-9 9.75 9.75 0 016.74 2.74L21 8m0 0v-4m0 4H17m-6 4a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          Volver a Inicio
        </button>

        {/* Footer */}
        <p className="text-xs text-text-muted text-center mt-6">
          Si el problema persiste, contacta con soporte
        </p>
      </div>
    </div>
  );
}
